import api from './axios';

export const obter = (idHospital, { idSecao, idSubsecao, formula, somenteCore } = {}) =>
  api.get(`/hospitais/${idHospital}/conformidade`, {
    params: { id_secao: idSecao, id_subsecao: idSubsecao, formula, somente_core: somenteCore },
  });

export const obterPorSecao = (idHospital, { formula, somenteCore } = {}) =>
  api.get(`/hospitais/${idHospital}/conformidade/por-secao`, {
    params: { formula, somente_core: somenteCore },
  });

export const obterHistorico = (idHospital, { formula, somenteCore, meses } = {}) =>
  api.get(`/hospitais/${idHospital}/conformidade/historico`, {
    params: { formula, somente_core: somenteCore, meses },
  });

// Todos os hospitais numa chamada só (Dashboard/lista de Hospitais) — evita 1 chamada por
// hospital.
export const obterTodosHospitais = ({ formula, somenteCore } = {}) =>
  api.get('/hospitais/conformidade', { params: { formula, somente_core: somenteCore } });

export const obterHistoricoTodosHospitais = ({ formula, somenteCore, meses } = {}) =>
  api.get('/hospitais/conformidade/historico', { params: { formula, somente_core: somenteCore, meses } });
